import { TitleService } from './../../shared/services/title.service';
import { environment } from '@env/environment';
import { Component, OnInit } from '@angular/core';
import { UsersService } from '@app/shared/services/users.service';
import { PhotoService } from '@app/shared/services/photo.service';
import { AlertService } from '@app/shared/services/alert.service';
import { Router } from '@angular/router';
import { MenuService } from '@app/shared/services/menu.service';

@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.scss']
})
export class RegisterComponent implements OnInit {

  public release : string = environment.release;
  public user : any = {
    email: '',
    gender: 'male',
    password: '',
    firstName: '',
    lastName: '',
    societyCode: '',
    mobile: '',
    age: ''
  };
  public passwordConfirmation: string = '';
  public loadingAccountCreation: boolean = false;
  public page: number = 1;

  public idRecto : any = null;
  public idVerso : any = null;
  public drivingRecto : any = null;
  public drivingVerso : any = null;

  constructor(
    private userService: UsersService,
    private photoService: PhotoService,
    private alertService: AlertService,
    private router: Router,
    private titleService: TitleService,
    private menu: MenuService

  ) { }

  ngOnInit(): void {
    this.titleService.setTitle(`Enregistrez-vous sur VOP`);
    this.menu.setMenuState('register', '', '');
  }

  modifyPhoto(part) : void {
    this.photoService.askFile().then((photo) => {
      switch (part) {
        case 1:
          this.drivingRecto = photo;
          break;
        case 2:
          this.drivingVerso = photo;
          break;
        case 3:
          this.idRecto = photo;
          break;
        case 4:
          this.idVerso = photo;
          break;
      }
    });
  }

  errorHandling(): number {
    if (this.loadingAccountCreation === true) {
      return 1;
    }
    if (this.passwordConfirmation !== this.user.password) {
      this.alertService.alert('Les mots de passe sont différents.');
      return 1;
    }
    if (this.user.email.includes('@') === false || this.user.email.includes('.') === false) {
      this.alertService.alert("L'adresse e-mail est invalide.");
      return 1;
    }
    if (this.page === 2 && (this.idRecto === null || this.idVerso === null || this.drivingRecto === null || this.drivingVerso === null)) { 
      this.alertService.alert("Veuillez ajouter les documents demandés.");
      return 1;
    }
    return 0;
  }

  nextPage(): number {
    if (this.page === 1) {
      this.page = 2;
      return 1;
    }
    return 0;
  }

  register(): void {
    if (this.errorHandling() === 1) { return; }
    if (this.nextPage() === 1) { return; }

    this.loadingAccountCreation = true;
    this.userService.registerUser(this.user, {
      identityCardBack: this.idVerso,
      identityCardFront: this.idRecto,
      drivingLicenseFront: this.drivingRecto,
      drivingLicenseBack: this.drivingVerso
    }, 0, this.user.societyCode).then((res: any) => {
      if (res.error && res.error.result_code === 2) {
        this.alertService.alert("Adresse e-mail déjà utilisé.");
      }
      if (res.body && res.body.result_code === 0) {
        this.alertService.alert("Votre compte a été créé.");
        this.router.navigate(['/login']);
      }
      this.loadingAccountCreation = false;
    });
  }

}
